module.exports = __webpack_public_path__ + "static/media/storieThree.21ed9596.jpg";